import Cookies from 'js-cookie';
import actions from './actions';

const initState = {
  login: Cookies.get('logedIn') === 'true',
  loading: false,
  error: null,
  userType: Cookies.get('userType') || null,
  adminId: Cookies.get('adminId') || null,
  borrowerId: Cookies.get('borrowerId') || null,
  investorId: Cookies.get('investorId') || null,
  facilitatorId: Cookies.get('facilitatorId') || null,
};

const authReducer = (state = initState, action) => {
  const { type, payload, err } = action;

  switch (type) {
    case actions.LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        login: payload.login,
        loading: false,
        error: null,
        userType: payload.userType,
        adminId: payload.adminId,
        borrowerId: payload.borrowerId,
        investorId: payload.investorId,
        facilitatorId: payload.facilitatorId,
      };

    case actions.LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
        login: false,
      };

    case actions.LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.LOGOUT_SUCCESS:
      return {
        ...initState,
        login: false,
        userType: null,
        adminId: null,
        borrowerId: null,
        investorId: null,
        facilitatorId: null,
      };

    case actions.LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;
